import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '@/app/store';

import { changeReasonCodeStatus } from '@/features/profiling/reasonCodeSlice';

import { Typography } from '@/components/ui/Typography';
import { UISwitch } from '@/components/ui/Switch';
import { StyledTablesRow } from './styles';

import type { ReasonCodeDetails } from '@/api/receive';

const ProfilinReasonCodeRow: React.FC<ReasonCodeDetails> = ({
  ...reasonCode
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { movementTypeCode, movementReasonCode, movementReason, enabled } =
    reasonCode;

  const switchChangeHandler = (): void => {
    dispatch(changeReasonCodeStatus(movementReasonCode || ''));
  };

  return (
    <StyledTablesRow>
      <Typography>{movementTypeCode}</Typography>
      <Typography>{movementReasonCode}</Typography>
      <Typography>{movementReason}</Typography>
      <UISwitch
        checkedLabel={t('enabled')}
        unCheckedLabel={t('disabled')}
        checked={enabled || false}
        onChange={(): void => switchChangeHandler()}
      />
    </StyledTablesRow>
  );
};

export default ProfilinReasonCodeRow;
